<template>
  <el-dialog :title="head" :visible.sync="dialogFormVisible" custom-class="max-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <span class="demonstration">开始日期</span>
            <el-date-picker style="width:150px"
                            v-model="beginDate" :value-format="'yyyy-MM-dd'"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
            <span class="demonstration">结束日期</span>
            <el-date-picker style="width:150px"
                            v-model="endDate" :value-format="'yyyy-MM-dd'"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>

            <el-input style="width:200px;"
                      placeholder="请输入标题"
                      prefix-icon="el-icon-search"
                      v-model="searchdata">
            </el-input>

            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
          </el-col>
        </div>

        <el-table
          :data="tableData"
          :height="tableHeight(220)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="left"
            header-align="left">
            <template slot-scope="scope">
              <div @click="lookDetails(scope.$index, scope.row)" style="cursor: pointer">{{scope.row.title}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="uname"
            label="发布者"
            align="center" width="120"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="dname"
            label="部门"
            align="left" width="150"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="日期" width="150">
            <template slot-scope="scope">
              {{(scope.row.startdate || "").substr(0, 10)}}
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="visittimes"-->
            <!--label="访问次数"-->
            <!--align="center"-->
            <!--header-align="center"-->
            <!--width="200"-->
          <!--&gt;-->
          <!--</el-table-column>-->


          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="lookDetails(scope.$index, scope.row)">查看
              </el-button>
            </template>

          </el-table-column>
        </el-table>
        <InforDetail ref="InforDetail" @bindInfoList="AfterDelete"></InforDetail>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
    </el-col>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getListData, getDetail} from '@/api/oa/inforlist';
  import InforDetail from './InforDetail';

  export default {
    name: 'HelloWorld2222',
    data() {
      return {
        dialogFormVisible: false,
        searchdata: "",
        head:'',
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        classcode: '',
        beginDate: '',
        endDate: '',
        tableData: [],
        controlData: {}
      }
    },
    props: {
      statuses: {
        default: ""
      },
    },
    methods: {
      lookDetails(index, row) {
        this.$refs.InforDetail.initData(row.unitguid);
      },
      AfterDelete(){
        this.$emit('bindInfoList',this.classcode);
        this.bindGrid();
      },
      bindGrid() {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          classcode: this.classcode,
          search: this.searchdata,
          beginDate: this.beginDate,
          endDate: this.endDate,
          status: 2
        }).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
        });

      },

      show(classcode) {
        if(classcode=='001')
          this.head="通知公告";
        else if(classcode=='002')
          this.head="最新动态";
        this.classcode = classcode;
        this.dialogFormVisible = true;
        this.tableData = [];
        this.bindGrid();

      },
      hide() {
        this.dialogFormVisible = false;
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show();
      }

    },
    mounted() {

    },
    components: {
      InforDetail,

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/oa/inforlist/InforListDialog.vue